const FOUR_WEEKS_3999_ONE_WEEK_693_TRIAL_PLAN = 'fourWeeks3999OneWeek693Trial';
const FOUR_WEEKS_3999_ONE_WEEK_1386_TRIAL_PLAN = 'fourWeeks3999OneWeek1386Trial';
const FOUR_WEEKS_3999_ONE_WEEK_1299_TRIAL_PLAN = 'fourWeeks3999OneWeek1299Trial';
const FOUR_WEEKS_3999_TWO_WEEKS_1399_TRIAL_PLAN = 'fourWeeks3999TwoWeeks1399Trial';
const FOUR_WEEKS_3999_TWO_WEEKS_1948_TRIAL_PLAN = 'fourWeeks3999TwoWeeks1948Trial';
const FOUR_WEEKS_3999_FOUR_WEEKS_1999_INTRO_PLAN = 'fourWeeks3999FourWeeks1999Intro';
const FOUR_WEEKS_3999_PLAN = 'fourWeeks3999';
const TWELVE_WEEKS_7999_TWELVE_WEEKS_3999_INTRO_PLAN = 'twelveWeeks7999TwelveWeeks3999Intro';
const TWELVE_WEEKS_7999_PLAN = 'twelveWeeks7999';
const FOUR_WEEKS_3527_FOUR_WEEKS_2558_INTRO_PLAN = 'fourWeeks3527FourWeeks2558Intro';
const TWELVE_WEEKS_6817_TWELVE_WEEKS_4763_INTRO_PLAN = 'twelveWeeks6817TwelveWeeks4763Intro';
const FOUR_WEEKS_3527_WITHOUT_TRIAL_PLAN = 'fourWeeks3527WithoutTrial';
const TWELVE_WEEKS_6817_WITHOUT_TRIAL_PLAN = 'twelveWeeks6817WithoutTrial';
const WEEK_1148_WEEK_693_INTRO_PLAN = 'week1148Week693Intro';
const FOUR_WEEKS_3527_FOUR_WEEKS_1999_INTRO_PLAN = 'fourWeeks3527FourWeeks1999Intro';
const TWELVE_WEEKS_6817_TWELVE_WEEKS_3999_INTRO_PLAN = 'twelveWeeks6817TwelveWeeks3999Intro';
const TWO_WEEKS_099_FOUR_WEEKS_1899_TRIAL_PLAN = 'twoWeeks099FourWeeks1899Trial';
const WEEK_693_FOUR_WEEKS_3527_INTRO_PLAN = 'week693FourWeeks3527Intro';
const WEEK_1155_FOUR_WEEKS_3527_INTRO_PLAN = 'week1155FourWeeks3527Intro';
const FOUR_WEEKS_0999_WITHOUT_TRIAL_PLAN = 'fourWeeks0999WithoutTrial';
const FOUR_WEEKS_099_WITHOUT_TRIAL_PLAN = 'fourWeeks099WithoutTrial';
const TWELVE_WEEKS_1999_WITHOUT_TRIAL_PLAN = 'twelveWeeks1999WithoutTrial';
const TWENTY_FOUR_WEEKS_3999_WITHOUT_TRIAL_PLAN = 'twentyFourWeeks3999WithoutTrial';
const TWENTY_FOUR_WEEKS_9999_WITHOUT_TRIAL_PLAN = 'twentyFourWeeks9999WithoutTrial';
const FOUR_WEEKS_1899_WITHOUT_TRIAL_PLAN = 'fourWeeks1899WithoutTrial';

export {
    FOUR_WEEKS_3999_ONE_WEEK_693_TRIAL_PLAN,
    FOUR_WEEKS_3999_ONE_WEEK_1386_TRIAL_PLAN,
    FOUR_WEEKS_3999_ONE_WEEK_1299_TRIAL_PLAN,
    FOUR_WEEKS_3999_TWO_WEEKS_1399_TRIAL_PLAN,
    FOUR_WEEKS_3999_TWO_WEEKS_1948_TRIAL_PLAN,
    FOUR_WEEKS_3999_FOUR_WEEKS_1999_INTRO_PLAN,
    FOUR_WEEKS_3999_PLAN,
    TWELVE_WEEKS_7999_TWELVE_WEEKS_3999_INTRO_PLAN,
    TWELVE_WEEKS_7999_PLAN,
    FOUR_WEEKS_3527_FOUR_WEEKS_2558_INTRO_PLAN,
    TWELVE_WEEKS_6817_TWELVE_WEEKS_4763_INTRO_PLAN,
    FOUR_WEEKS_3527_WITHOUT_TRIAL_PLAN,
    TWELVE_WEEKS_6817_WITHOUT_TRIAL_PLAN,
    WEEK_1148_WEEK_693_INTRO_PLAN,
    FOUR_WEEKS_3527_FOUR_WEEKS_1999_INTRO_PLAN,
    TWELVE_WEEKS_6817_TWELVE_WEEKS_3999_INTRO_PLAN,
    WEEK_693_FOUR_WEEKS_3527_INTRO_PLAN,
    WEEK_1155_FOUR_WEEKS_3527_INTRO_PLAN,
    TWO_WEEKS_099_FOUR_WEEKS_1899_TRIAL_PLAN,
    FOUR_WEEKS_0999_WITHOUT_TRIAL_PLAN,
    FOUR_WEEKS_099_WITHOUT_TRIAL_PLAN,
    TWELVE_WEEKS_1999_WITHOUT_TRIAL_PLAN,
    TWENTY_FOUR_WEEKS_3999_WITHOUT_TRIAL_PLAN,
    TWENTY_FOUR_WEEKS_9999_WITHOUT_TRIAL_PLAN,
    FOUR_WEEKS_1899_WITHOUT_TRIAL_PLAN
};
